import React, {Component} from 'react';
import FlatButton from 'material-ui/FlatButton';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import {List, ListItem} from 'material-ui/List';

class RetIvaCard extends Component {
    render() {
        let item = this.props.item;
        const tipo = ['', 'Factura', 'N/D', 'N/C'];
        const actions = this.props.actions.map((item, index) => {
            return <FlatButton
                key={index} 
                onTouchTap={item.onTouchTap}
                label={item.primaryText}
                {...item} />;
        });

        return (
             <Card {...this.props}>
                <CardHeader
                title={item.primaryText}
                subtitle={<span>{item.proveedor.name}<br />{item.date}</span>}
                actAsExpander={true}
                showExpandableButton={true}
                textStyle={{paddingRight:40}}
                />
                <CardText expandable={true} style={{padding:'8px 16px'}}>
                    <List >
                        <ListItem
                            disableTouchRipple={true}
                            innerDivStyle={{padding:'5px 1px 5px 1px'}}
                            primaryText={"Lineas: "+item.facturas.length}
                                />
                        <ListItem
                            disableTouchRipple={true}
                            innerDivStyle={{padding:1}}
                            primaryText={
                                item.facturas.map((factura, index) => (
                                    <div key={index} style={{marginBottom:10}}>
                                        <div style={{marginBottom:5}}>
                                        <span>Tipo:</span>
                                        <span>{tipo[parseInt(factura.tipo)]}</span>
                                        </div>
                                        <span>N°:{factura.numeroDoc} | </span>
                                        <span>Retención: {parseFloat(factura.retencion).fmtd()}</span>
                                    </div>
                                ))
                            }/>
                    </List>
                </CardText>
                <CardActions expandable={true}>
                {actions}
                </CardActions>
            </Card>
        );
    }
}

export default RetIvaCard;


/** WEBPACK FOOTER **
 ** ./app-react/components/RetIvaCard.jsx
 **/